import PropTypes from "prop-types";
import React from "react";
import MediaQuery from "react-responsive";

import settings from "config/settings";

import {Route} from "v2/api/Records";
import {formatTimeConstraints} from "v2/api/TimeConstraints";

import DestinationAddress from "v2/components/DestinationAddress";
import DestinationFlag from "v2/components/DestinationFlag";
import DestinationTitle from "v2/components/DestinationTitle";
import DestinationTimings from "v2/components/DestinationTimings";
import {DESTINATION_TYPE} from "config/constants";
import Notes from "v2/components/Notes";
import NotFoundError from "v2/components/NotFoundError";
import Tasks from "v2/components/Tasks";

import styles from "v2/styles";

export const DestinationPage = (props, context) => {
  const {params: {id}, routeData} = context;

  const destinationId = parseInt(id, 10);

  if (routeData.destinations === undefined || routeData.destinations === null || routeData.destinations.size === 0) {
    return <div />;
  }

  const data = routeData.destinations.find(item => item.id === destinationId);
  const errorData = "The selected destination is not part of this route.";

  if (!data) {
    return <NotFoundError message={errorData} />;
  }

  const timeConstraints = data.house && !data.house.timeConstraints.isEmpty() && (
    <Notes
      key="time-constraints"
      label="Time Constraints"
      type="warning">
      {formatTimeConstraints(data.house.timeConstraints, true)}
    </Notes>
  );
  const schedulerNotes = data.schedulerNotes && (
    <Notes
      key="scheduler-notes"
      label="Internal Scheduling Notes"
      type="scheduler">
      {data.schedulerNotes}
    </Notes>
  );
  const readFirstNote = data.readFirstNote && (
    <Notes
      key="read-first-notes"
      label="Read First Note For Gardener"
      type="note">
      {data.readFirstNote}
    </Notes>
  );

  const isTraineeDestination = (data.type === DESTINATION_TYPE.pickupTrainee ||
    data.type === DESTINATION_TYPE.dropoffTrainee);
  const traineeDestinationNote = isTraineeDestination ?
    <span className="text-muted">Destination hidden from trainee&apos;s route</span> :
    null;

  let secondSeparator;
  if (timeConstraints ||
      schedulerNotes ||
      data.importantNotes ||
      data.notes ||
      traineeDestinationNote) {
    secondSeparator = <hr key="separator-2" />;
  }

  let firstNotes;
  const firstNotesList = [];

  if (readFirstNote) {
    firstNotesList.push(readFirstNote);
  }
  if (timeConstraints) {
    firstNotesList.push(timeConstraints);
  }
  if (schedulerNotes) {
    firstNotesList.push(schedulerNotes);
  }

  if (firstNotesList.length > 1) {
    firstNotes = (
      <div className="row" key="first-notes">
        {firstNotesList.map((note, noteIdx) => (
          <div className="col-md-6 col-xs-12" key={noteIdx}>
            {note}
          </div>
        )).reduce((result, elem) => {
          return result === null ? [elem] : [...result, elem];
        }, null)}
      </div>
    );
  } else if (firstNotesList.length == 1) {
    firstNotes = firstNotesList[0];
  }

  const content = [
    <div className="erg-margin-bottom-10" key="info">
      <DestinationTitle
        data={data}
        style={{fontSize: styles.FONT_SIZE.LARGE}} />
      <DestinationFlag data={data} /><br />
      <DestinationAddress crmLink data={data} />
    </div>,
    <DestinationTimings data={data} key="timings" />,

    <hr key="separator-1" />,

    firstNotes,
    <Notes key="important-notes" label="Important Notes" type="warning">
      {data.importantNotes}
    </Notes>,
    <Notes key="notes" label="Notes" type="info">{data.notes}</Notes>,
    traineeDestinationNote,

    secondSeparator,

    <Tasks data={data.tasks} key="tasks" />,
  ];
  const desktopHeight = settings.LEVEL === "production" ? 250 : 300;

  return (
    <div className="DestinationPage">
      <MediaQuery
        className="DestinationPage-Padding"
        component="div"
        minWidth={768}
        style={styles.scrollableSidebar(desktopHeight)}>
        {content}
      </MediaQuery>
      <MediaQuery className="DestinationPage-Padding" maxWidth={768}>
        {content}
      </MediaQuery>
    </div>
  );
};

DestinationPage.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  routeData: PropTypes.instanceOf(Route),
};

export default DestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/DestinationPage.js
 **/